<template>
  <div class="product-widget mb-30">
    <h5 class="pt-title">Choose Brand</h5>
    <div class="widget-category-list mt-20">
      <div class="single-widget-category pointer" v-for="brand in brands_data" :key="brand.id">
        <input type="checkbox" :id="`brand-item-${brand.id}`" :class="{ checked: activeBrand == brand.id }">
        <label @click="handleBrandRoute(brand.id)" :for="`brand-item-${brand.id}`" class="pointer">
          {{ brand.name }} <span></span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductBrands",
  data() {
    return {
      brands_data: [], // Initialize as an empty array
      activeBrand: "",
    }
  },
  watch: {
    "$route.query.web_category": {
      handler(newWebCategory) {
        this.fetchBrands(newWebCategory) // Fetch brands when web_category changes
      },
      immediate: true, // Trigger on initial load
    },
    "$route.query.brand": {
      handler(newBrand) {
        this.activeBrand = newBrand || '' // Update activeBrand when the brand changes
      },
      immediate: true, // Trigger on initial load
    },
  },
  methods: {
    async fetchBrands(web_category = this.$route.query.web_category) {
      try {
        const category = this.$route.query.category // Get category from the query (if exists)
        const response = await this.$axios.get('/website-prodcut-brands', {
          params: { category, web_category }, // Pass category and web_category as query parameters
        })
        this.brands_data = response.data
      } catch (error) {
        console.error("Error fetching brands:", error)
      }
    },
    handleBrandRoute(value) {
      const currentQuery = { ...this.$route.query } // Get existing query params
      currentQuery.brand = value // Update the brand query param

      this.$router.push({
        path: '/shop',
        query: currentQuery, // Keep existing query parameters (including web_category)
      })
    },
    formatUrl(value) {
      return value.toLowerCase().replace(/\s+/g, '-')
    },
  },
  mounted() {
    this.activeBrand = this.$route.query.brand // Set active brand from the route query
    this.fetchBrands() // Fetch brands when the component is mounted
  },
}
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
.single-widget-category label::after {
  font-family: 'Font Awesome 5 Free';
  content: '\f00c';
  font-weight: 900;
  /* Ensures solid icon */
}
</style>
